/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCronStore } from '../../../stores/cron'

interface IRunnerParam {
  runImmediately?: boolean
  runOnce?: boolean
  frequency?: number // Milliseconds
}

export abstract class CronTask {
  /**
   * Cron store of cron task
   */
  private cronStore = useCronStore()

  /**
   * Default runner param of cron task
   */
  abstract defaultRunnerParam: IRunnerParam

  /**
   * Store cron task enum of cron task
   */
  abstract storeCronTaskEnum: string

  /**
   * Init store to undefined
   */
  protected init(): void {
    this.cronStore[this.storeCronTaskEnum] = undefined
  }

  /**
   * Define the content of the task
   */
  abstract task(taskParams?: any): Promise<void>

  /**
   * Starts the task
   */
  public async run(runnerParams: IRunnerParam, taskParams?: any): Promise<void> {
    this.defaultRunnerParam.frequency = runnerParams.frequency ?? this.defaultRunnerParam.frequency
    this.defaultRunnerParam.runImmediately = runnerParams.runImmediately ?? this.defaultRunnerParam.runImmediately
    this.defaultRunnerParam.runOnce = runnerParams.runOnce ?? this.defaultRunnerParam.runOnce

    // Stop the task if it is already in execution
    if (this.cronStore[this.storeCronTaskEnum] !== undefined) {
      this.stop()
    }

    // Run the task once
    if (this.defaultRunnerParam.runImmediately || this.defaultRunnerParam.runOnce) {
      this.task(taskParams)
    }

    // Run the task indefinitely
    if (!this.defaultRunnerParam.runOnce) {
      const intervalTimer: number = window.setInterval(() => {
        this.task(taskParams)
      }, this.defaultRunnerParam.frequency)

      // Store the timer
      if (intervalTimer !== this.cronStore[this.storeCronTaskEnum]) {
        this.cronStore[this.storeCronTaskEnum] = intervalTimer
      }
    }
  }

  /**
   * Stops the task
   */
  public stop(): void {
    if (this.cronStore[this.storeCronTaskEnum]) {
      window.clearInterval(this.cronStore[this.storeCronTaskEnum])
    }
    this.init()
  }
}
